import React from 'react';
import PropTypes from 'prop-types';
import css from './DotMarkerPopup.module.css';
import Directions from "../Directions";
import {connect} from "react-redux";
import {S2MarkerType} from "../../../utils/s2";

const GymMarkerPopup = (props) => {
	const {portal} = props;

	navigator.clipboard && navigator.clipboard.writeText(portal.latitude + ", " + portal.longitude);

	return (<div className={css.DotMarkerPopup}>
		<div className={css.HeaderLine}>
			{props.name}
		</div>

		{props.type === S2MarkerType.PENDING &&
			<div>Submitted by {portal.username} {Math.floor(portal.days_ago)}d ago</div>
		}

		{props.type === S2MarkerType.GYM &&
			<div>Existing gym</div>
		}

		{props.type === S2MarkerType.STOP &&
			<div>Existing stop</div>
		}

		{props.type === S2MarkerType.PORTAL &&
			<div>Existing portal in Ingress that's not in Pokemon Go (but still can block submissions within 20m of it)</div>
		}

		<Directions id={props.id} latitude={portal.latitude} longitude={portal.longitude} />
	</div>);
};


GymMarkerPopup.propTypes = {
	name: PropTypes.string.isRequired,
	type: PropTypes.number.isRequired,
	portal: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: () => dispatch(FN())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GymMarkerPopup);